import { SOURCE_MAP, TrafficType } from "./page-config";

export const UTM_KEYS = [
  "utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term",
] as const;

export const AD_CLICK_IDS = ["yclid", "gclid", "fbclid", "ymclid"] as const;

export type UtmBundle = {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_term?: string;
  yclid?: string;
  gclid?: string;
  fbclid?: string;
  ymclid?: string;
  erid?: string;
  referrer?: string;
  landedAt?: string;
};

export const COOKIE_FIRST_TOUCH = "tlr_ft";
export const COOKIE_LAST_TOUCH  = "tlr_lt";
export const COOKIE_ERID        = "tlr_erid";
export const COOKIE_SESSION     = "tlr_sid";
export const COOKIE_CONSENT     = "tlr_consent";

export const FIRST_TOUCH_MAX_AGE = 60 * 60 * 24 * 30;  // 30 days
export const LAST_TOUCH_MAX_AGE  = 60 * 60 * 24;        // 1 day
export const ERID_MAX_AGE        = 60 * 60 * 24 * 7;    // 7 days
export const SESSION_MAX_AGE     = 60 * 60 * 2;          // 2 hours

/** Extract UTM/click-id/erid from URL query */
export function extractUtm(url: URL): UtmBundle {
  const bundle: UtmBundle = {};
  for (const k of UTM_KEYS) {
    const v = url.searchParams.get(k);
    if (v) bundle[k] = v.slice(0, 200);
  }
  for (const k of AD_CLICK_IDS) {
    const v = url.searchParams.get(k);
    if (v) bundle[k] = v.slice(0, 200);
  }
  const erid = url.searchParams.get("erid");
  if (erid) bundle.erid = erid.slice(0, 100);
  return bundle;
}

export function hasUtm(bundle: UtmBundle): boolean {
  return Boolean(
    bundle.utm_source || bundle.utm_medium || bundle.utm_campaign ||
    bundle.yclid || bundle.gclid || bundle.fbclid || bundle.ymclid,
  );
}

export function serializeCookie(bundle: UtmBundle): string {
  try { return encodeURIComponent(JSON.stringify(bundle)); }
  catch { return ""; }
}

export function parseCookie(raw: string | undefined): UtmBundle | null {
  if (!raw) return null;
  try { return JSON.parse(decodeURIComponent(raw)) as UtmBundle; }
  catch { return null; }
}

/** Map a raw utm_source or source string to our canonical TrafficType */
export function resolveTrafficType(source: string | undefined): TrafficType {
  if (!source) return "warm";
  const s = source.toLowerCase();
  if (SOURCE_MAP[s]) return SOURCE_MAP[s];
  if (s.includes("yandex")) return "cold";
  if (s.includes("google")) return "cold";
  if (s.includes("telegram") || s.includes("tg")) return "cold";
  if (s.includes("vk")) return "cold";
  if (s.includes("retarget") || s.includes("rtg")) return "retarget";
  if (s.includes("email") || s.includes("push")) return "warm";
  return "warm";
}

/** Generate a short session id */
export function generateSessionId(): string {
  return Math.random().toString(36).slice(2, 12) + Date.now().toString(36);
}
